import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiCheckCircle, HiMail, HiArrowLeft } from 'react-icons/hi';

const ContactSuccess = () => {
  const location = useLocation();
  const name = location.state?.name || 'User';

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains('dark-mode'));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  // Confetti effect inside the card header
  const confetti = (
    <div className="registration-success-confetti">
      {[...Array(30)].map((_, i) => (
        <div
          key={i}
          className="registration-success-confetti-dot"
          style={{
            position: 'absolute',
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 60}px`,
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: `hsl(${Math.random() * 360}, 80%, 60%)`,
            opacity: 0.7,
            animation: `fall 1.5s ${Math.random()}s ease-in-out infinite`,
          }}
        />
      ))}
    </div>
  );

  return (
    <div className="registration-success-root">
      <div className="registration-success-card">
        <div className="registration-success-header">
          {confetti}
          <div className="registration-success-header-icon">
            <HiCheckCircle style={{ width: 56, height: 56, color: 'white', filter: 'drop-shadow(0 2px 8px #059669)' }} />
          </div>
          <h1 className="registration-success-header-title">
            Message Sent Successfully!
          </h1>
          <p className="registration-success-header-welcome">
            Thank you for contacting us
          </p>
        </div>
        <div className="registration-success-content">
          <div className="registration-success-company">
            <h2 className="registration-success-company-title">
              Hi {name}, your message has been received!
            </h2>
            <p className="registration-success-company-greeting">
              Our support team will get back to you as soon as possible.
            </p>
          </div>
          <div className="registration-success-card-info">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <HiMail style={{ width: 28, height: 28, color: isDarkMode ? '#38bdf8' : '#2563eb', marginTop: 2, flexShrink: 0 }} />
              <div>
                <p>
                  We appreciate you reaching out. If your inquiry is urgent, please use the phone number below to talk to one of our staff members. Otherwise, we will reply by email as soon as possible.
                </p>
              </div>
            </div>
          </div>
          <div className="registration-success-card-office">
            <h3>Contact Details</h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <HiMail style={{ width: 22, height: 22, color: isDarkMode ? '#38bdf8' : '#64748b', flexShrink: 0 }} />
              <a href="mailto:info@nexagensolution.com" className="office-email">info@nexagensolution.com</a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <span className="office-title">Phone:</span>
              <a href="tel:+923156666402" className="office-phone">+92 315 666 6402</a>
              <span className="office-separator">|</span>
              <a href="tel:+923037682000" className="office-phone">+92 303 7682000</a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span className="office-title">Address:</span>
              <span className="office-address">Ali Mall, 2nd Floor, Susan Road, Faisalabad, Pakistan</span>
            </div>
          </div>
          <div className="registration-success-footer">
            <p>Best Regards,</p>
            <p className="footer-team">Nexagen Solution Support Team</p>
          </div>
          <Link
            to="/"
            className="registration-success-home-link"
          >
            <HiArrowLeft style={{ width: 22, height: 22 }} />
            <span>Return to Home</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactSuccess; 